import { render, staticRenderFns } from "./TopoDeclaracoes.vue?vue&type=template&id=5cd1fed9&"
import script from "./TopoDeclaracoes.vue?vue&type=script&lang=js&"
export * from "./TopoDeclaracoes.vue?vue&type=script&lang=js&"
import style0 from "./TopoDeclaracoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports